import styled from "styled-components"

import { Banner, Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { chargebeeAddonUrl } from "src/constants/hrefs"
import { prettifyApiFieldValue } from "src/data/orders/orderUtils"
import { getWMSLink } from "src/data/paradise/paradiseOrders/logic/paradiseOrderLogic"
import { TParadiseOrder } from "src/data/paradise/paradiseOrders/paradiseOrderTypes"
import { ExternalLink } from "src/ui/Link/ExternalLink"
import { spacing } from "src/ui/spacing"

export function ParadiseOrderFulfillment({ order }: { order: TParadiseOrder }) {
  return (
    <div>
      <Grid>
        <ParadiseDetailsSection title="Fulfillment">
          {order.partial_fulfillment && (
            <PartialFulfillmentBanner type="info" fullWidth>
              This order is part of a partially fulfilled shipment
            </PartialFulfillmentBanner>
          )}
          <WarehouseSection order={order} />
        </ParadiseDetailsSection>
      </Grid>
    </div>
  )
}

function WarehouseSection({ order }: { order: TParadiseOrder }) {
  return (
    <div>
      <div>
        <Text variant="bodyS" color="secondary" as="span">
          Assigned warehouse:
        </Text>{" "}
        <Text variant="bodyS" as="span">
          <ExternalLink
            href={getWMSLink(order.assigned_warehouse)}
            showExternalIcon
          >
            {prettifyApiFieldValue(order.assigned_warehouse)}
          </ExternalLink>
        </Text>
      </div>

      <div>
        <Text variant="bodyS" color="secondary" as="span">
          Shipping method:
        </Text>{" "}
        <Text variant="bodyS" as="span">
          {order.shipping_line_item?.shipping_method_id ? (
            <ExternalLink
              showExternalIcon
              openInNewTab
              href={chargebeeAddonUrl(
                order.shipping_line_item?.shipping_method_id
              )}
            >
              {order.shipping_line_item.name}
            </ExternalLink>
          ) : (
            "-"
          )}
        </Text>
      </div>

      <div>
        <Text variant="bodyS" color="secondary" as="span">
          Tracking reference:
        </Text>{" "}
        <Text variant="bodyS" as="span">
          {order.tracking_reference}
        </Text>
      </div>

      <div>
        <Text variant="bodyS" color="secondary" as="span">
          Tracking url:
        </Text>{" "}
        {order.tracking_url && (
          <Text variant="bodyS" as="span">
            <ExternalLink href={order.tracking_url}>View</ExternalLink>
          </Text>
        )}
      </div>
    </div>
  )
}

const Grid = styled.div`
  display: grid;
  gap: ${spacing.XS2};
`

const PartialFulfillmentBanner = styled(Banner)`
  margin-bottom: ${spacing.XS};
`
